import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { generateUUID } from 'syf-js-utilities';
import { useMultiPaymentQueryAtoms } from '../../../../store/multiPaymentAtoms';
import { t } from '../../../../strings/i18n';
import MultiPaymentSection from '../../../../ui/organisms/DigitalCollections/MultiPaymentFlow/MultiPaymentSection';
import { TextCenterWrapper } from './subcomponents';
const FlowWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.small}px 0;

  @media ${query.lessThanMedium} {
    padding: 0;
  }
`;
const MultiPaymentFlow = () => {
    const { settlementEligibilityQueryResult: { data: settlementEligibility } } = useMultiPaymentQueryAtoms();
    const paymentArrangementPlans = useMemo(() => settlementEligibility === null || settlementEligibility === void 0 ? void 0 : settlementEligibility.paymentArrangementPlans.map((v) => (Object.assign(Object.assign({}, v), { id: generateUUID() }))), [settlementEligibility === null || settlementEligibility === void 0 ? void 0 : settlementEligibility.paymentArrangementPlans]);
    return (_jsxs(_Fragment, { children: [_jsxs(FlowWrapper, { children: [_jsx(TextCenterWrapper, { children: _jsx(Body, Object.assign({ weight: "bold" }, { children: t('multiPaymentFlow.schedulePayments') })) }), _jsx(Body, { children: t('label.allFieldRequiredInstruction') })] }), paymentArrangementPlans === null || paymentArrangementPlans === void 0 ? void 0 : paymentArrangementPlans.map((plan, index) => {
                return (_jsx(Inset, Object.assign({ "data-scroll": `multi-payment-${index}` }, { children: _jsx(MultiPaymentSection, { fieldNamePrefix: index, id: index, plan: plan }) }), `multi-payment-${plan.id}`));
            })] }));
};
export default MultiPaymentFlow;
